(function($) {

    const   $trigger = $('#seatbelts-intro');

    if ($trigger.length > 0) {
        
        let isPlaying = false;        

        const   $bg    = document.getElementById('s_0'),
                $s1    = document.getElementById('s_1'),
                $s2    = document.getElementById('s_2'),
                $s3    = document.getElementById('s_3'),
                $s4    = document.getElementById('s_4'),
                $s5    = document.getElementById('s_5'),
                $s6    = document.getElementById('s_6');

        let tl = gsap.timeline({paused: true});

        tl.fromTo($bg, {opacity: 0}, {opacity: 1, duration: .25, ease: "power2.in"});
        tl.add('bgDone');
        tl.fromTo($s1, {x: "-100%", opacity: 0}, {x: "2%", opacity: 1, duration: .75, ease: "power2.in"}, 'bgDone')
        tl.fromTo($s2, {x: "100%", opacity: 0}, {x: "-2%", opacity: 1, duration: .75, ease: "power2.in"}, 'bgDone');
        tl.add('textIn');
        tl.to($s1, {delay: .5, x: 0, duration: .25, ease: "power2.in"}, 'textIn');
        tl.to($s2, {delay: .5, x: 0, duration: .25, ease: "power2.in"}, 'textIn');
        tl.add('textOut');
        tl.fromTo($s4, {x: "3%", y: "-100%", opacity: 0}, {delay: .25, x: 0, y: 0, opacity: 1, duration: .5, ease: "power2.in"}, 'textIn')
        tl.fromTo($s5, {x: "-3%", y: "100%", opacity: 0}, {delay: .25, x: 0, y: 0, opacity: 1, duration: .5, ease: "power2.in"}, 'textIn');

        tl.fromTo($s3, {scale: 2.5, opacity: 0}, {delay: .5, transformOrigin: "65% 70%", x: 0, y: 0, scale: 1, opacity: 1, ease: "power2.in", duration: .25});


        function inViewport(elem) {
            let elementTop = $(elem).offset().top;
            let elementBottom = elementTop + $(elem).outerHeight();
            let viewportTop = $(window).scrollTop();
            let viewportBottom = viewportTop + $(window).height();

            return elementBottom > viewportTop && elementTop < viewportBottom;
        }

        // Animation trigger
        $(window).on('scroll', function(){
            let inView = inViewport($trigger);
            if (inView && !isPlaying) {
                tl.play();
            }
        });

    }

})(jQuery);